import Spinner from "../../ui/spinner"

const Loading = () => {
    return <div className='fixed inset-0 z-[999] bg-white opacity-60 w-screen h-screen grid place-items-center'>
        <Spinner />
    </div>
}

export default Loading
